import { useTranslation } from "react-i18next";
import { useShowMore } from "../../../hooks/useShowMore";
import {
    BoldText, ButtonDiv, CruiseSubHeader, CruiseWrapper, Description, ListItem, ListTitle, ShowMoreButton, ShowMoreContent, StyledList, AddressLink, ContactInfo, ContactSection, ContactWrapper, LinkWrapper, PhoneIcon, PinIcon, BookingIcon, StatuteIcon, SubHeader,
} from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";

const Houses = () => {
    const { t } = useTranslation("houses");
    const { showAll, handleToggle, buttonRef } = useShowMore();

    const offerItems = t("sections.offer.items", { returnObjects: true });
    const attractionsItems = t("sections.attractions.items", { returnObjects: true });

    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => (
                <ListItem key={idx}>
                    <BoldText>{item.label} </BoldText>
                    {item.text}
                </ListItem>
            ))}
        </StyledList>
    );

    return (
        <CruiseWrapper>
            <StaggeredContainer>
                <ShowMoreContent $isVisible={showAll}>
                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.equipment.title")}</CruiseSubHeader>
                    </StaggeredItem>

                    <StaggeredItem>
                        <Description>{t("sections.equipment.intro")}</Description>
                    </StaggeredItem>

                    <StaggeredItem>
                        <ListTitle>{t("sections.offer.title")}</ListTitle>
                    </StaggeredItem>

                    <StaggeredItem>{renderList(offerItems)}</StaggeredItem>

                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.terrace.title")}</CruiseSubHeader>
                    </StaggeredItem>

                    <StaggeredItem>
                        <Description>{t("sections.terrace.text")}</Description>
                    </StaggeredItem>

                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.location.title")}</CruiseSubHeader>
                    </StaggeredItem>

                    <StaggeredItem>
                        <Description>{t("sections.location.text")}</Description>
                    </StaggeredItem>

                    <StaggeredItem>
                        <CruiseSubHeader>{t("sections.attractions.title")}</CruiseSubHeader>
                    </StaggeredItem>

                    <StaggeredItem>
                        <ListTitle>{t("sections.attractions.subtitle")}</ListTitle>
                        {renderList(attractionsItems)}
                    </StaggeredItem>

                    <StaggeredItem>
                        <ContactWrapper>
                            <ContactSection>
                                <SubHeader>{t("sections.contact.header")}</SubHeader>

                                <ContactInfo style={{ whiteSpace: "pre-line" }}>
                                    {t("sections.contact.text")}
                                </ContactInfo>

                                <LinkWrapper>
                                    <AddressLink href={LINKS.housesPhone} title={t("sections.address.phoneTitle")}>
                                        <PhoneIcon /> {t("sections.contact.phoneDisplay")}
                                    </AddressLink>
                                </LinkWrapper>

                                <LinkWrapper>
                                    <AddressLink href={LINKS.housesBooking} target="_blank" rel="noopener noreferrer">
                                        <BookingIcon />
                                        {t("sections.contact.bookingText")}
                                    </AddressLink>
                                </LinkWrapper>

                                <LinkWrapper>
                                    <AddressLink href={LINKS.housesRulesPdf} target="_blank" rel="noopener noreferrer">
                                        <StatuteIcon />
                                        {t("sections.contact.rulesText")}
                                    </AddressLink>
                                </LinkWrapper>
                            </ContactSection>

                            <ContactSection>
                                <SubHeader>{t("sections.address.header")}</SubHeader>

                                <ContactInfo>
                                    {t("sections.address.name")}
                                    <br />
                                    {t("sections.address.street")}
                                    <br />
                                    {t("sections.address.city")}

                                    <LinkWrapper>
                                        <AddressLink
                                            href={LINKS.housesMaps}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={t("sections.address.mapsTitle")}
                                        >
                                            <PinIcon />
                                            {t("sections.address.navigate")}
                                        </AddressLink>
                                    </LinkWrapper>
                                </ContactInfo>
                            </ContactSection>
                        </ContactWrapper>
                    </StaggeredItem>
                </ShowMoreContent>

                <ButtonDiv>
                    <ShowMoreButton onClick={handleToggle} ref={buttonRef}>
                        {showAll ? t("toggle.hide") : t("toggle.show")}
                    </ShowMoreButton>
                </ButtonDiv>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Houses;